import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService } from 'ngx-webstorage';
import { QuoteService } from '../../../quote/quote.service';
import { AlQuoteService } from '../../../quote/alpaca/al-quote/al-quote.service';
import { QuoteVersions } from '../../../quote/alpaca/model/quote/quote_versions.model';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PolicyService } from '../../policy.service';

@Component({
  selector: 'app-al-policy-details',
  templateUrl: './policy-details.component.html',
  styleUrls: ['./policy-details.component.css']
})
export class AlPolicyDetailsComponent implements OnInit {
  quoteData = new QuoteVersions();
  staticData;
  isAdmin = false;
  latestVersion: number = 0;
  is_NTU: boolean = false;

  constructor(private route: ActivatedRoute, private quoteService: QuoteService, private sessionSt: LocalStorageService,
    private router: Router, private modalService: NgbModal, private _snackBar: MatSnackBar, private policyService: PolicyService) { }


  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;
  isPolicy: boolean = false;

  ngOnInit(): void {
    if (this.sessionSt.retrieve('company_role') != 'Broker') {
      this.isAdmin = true;
    }
    // GET QUOTE DETAILS
    this.quoteService.getQuoteDetailsByQuoteID(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.quoteData = response.result;
            this.latestVersion = response.result.sequence_number;
          }
        },
        (error) => {
          console.log(error);
        }
      );


  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  quoteDetailsUpdated(quotedata) {
    this.quoteData = quotedata;
  }


  /*
   * Convet To MTA PopUp - List of Reasons
   */
  mtaMsg: string = '';
  policyActions(content, type, delete_mta = 0) {
    if (type == 3) {
      this.policyService.mtaCheck(this.quoteData.quote_meta_id, delete_mta)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.modalService.dismissAll();
              this.router.navigateByUrl("/alpaca-admin/pre-qualifier/" + this.quoteData.id + '/' + type);
            } else {
              this.modalService.open(content, { centered: true });
              this.mtaMsg = response.message;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      this.router.navigateByUrl("/alpaca-admin/pre-qualifier/" + this.quoteData.quote_meta_id + '/' + type);
    }
  }

}
